import { isNil } from 'ramda'
import { GrowthBookClient } from '@growthbook/growthbook'

import type { FeatureApiResponse } from '@growthbook/growthbook-react'

import { FlagAttributeName, FlagDefinition } from '~/lib/featureFlags/types'

export const defineFlag = <
  TValue,
  TAttributeName extends FlagAttributeName = never
>(definition: {
  key: string
  default: TValue
  attributes?: ReadonlyArray<TAttributeName>
}): FlagDefinition<TValue, TAttributeName> => ({
  ...definition,
  attributes: definition.attributes ?? [],
})

export const hasRequiredAttributes = (
  flag: FlagDefinition,
  attributes: Partial<Record<FlagAttributeName, unknown>> | undefined
): boolean => flag.attributes.every((name) => !isNil(attributes?.[name]))

const evaluators = new WeakMap<FeatureApiResponse, GrowthBookClient>()

export const getEvaluator = (payload: FeatureApiResponse): GrowthBookClient => {
  let evaluator = evaluators.get(payload)

  if (!evaluator) {
    evaluator = new GrowthBookClient().initSync({ payload })
    evaluators.set(payload, evaluator)
  }

  return evaluator
}
